// lib/http.ts
import axios from 'axios';
import { useAuthStore } from '@/store/auth';
import { env } from '@/shared/config';

export const http = axios.create({
  baseURL: `${env.apiBase}/${env.apiPrefix}`,
  withCredentials: true,
});

http.interceptors.request.use((config) => {
  return config;
});

http.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401 && !env.authBypass) {
      const currentPath = window.location.pathname;

      if (currentPath === '/login') {
        return Promise.reject(err);
      }

      useAuthStore.getState().logout();
    }
    return Promise.reject(err);
  }
);
